import * as React from "react"
const ValidationConf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={51}
    height={49}
    fill="none"
    {...props}
  >
    <path
      fill="#11BFA4"
      d="M47.536 1.895c-8.013 9.33-16.026 18.665-24.04 27.995l-9.404-10.466c-1.557-1.732-4.103.828-2.555 2.554 3.57 3.974 7.14 7.948 10.71 11.919.617.688 1.943.713 2.555 0 8.43-9.816 16.86-19.632 25.286-29.448 1.508-1.757-1.036-4.322-2.552-2.555Z"
    />
    <path
      fill="#11BFA4"
      d="M44.538 17.63c3.06 9.864-.904 20.604-10.276 25.37-8.371 4.255-18.908 2.194-25.068-4.885-6.177-7.1-6.8-17.758-1.447-25.513C13.991 3.558 26.054 1.255 35.5 6.544c2.029 1.137 3.852-1.98 1.823-3.118C20.315-6.095-1.528 7.016.594 26.925c1.955 18.33 23.72 28.235 38.688 17.2 8.6-6.34 11.873-17.343 8.737-27.455-.686-2.214-4.174-1.27-3.481.96Z"
    />
  </svg>
)
export default ValidationConf
